import React, { PureComponent } from 'react';
import { defineMessages, injectIntl, useIntl } from 'react-intl';
import classnames from 'classnames';
import { FaRegQuestionCircle } from 'react-icons/fa';
import PropTypes from 'prop-types';
import intlShape from '@/shared/utils/intlShape';

const messages = defineMessages({
  OpenZendeskArticle: 'OpenZendeskArticle',
});

const zendeskBaseUrl = 'https://adminpulse.zendesk.com/hc';
const fallbackCulture = 'en-us';

const mapCulture = culture => {
  if (!culture) return fallbackCulture;
  if (culture.startsWith('en')) return 'en-us';
  if (culture.startsWith('nl')) return culture;
  if (culture.startsWith('fr')) return culture;
  return fallbackCulture;
};
export const getZendeskUrl = (articleOrSection, culture, isSection, anchor) => {
  if (!articleOrSection) return `${zendeskBaseUrl}/${mapCulture(culture)}`;
  if (isSection) {
    return `${zendeskBaseUrl}/${mapCulture(culture)}/sections/${articleOrSection}`;
  }
  if (anchor) {
    return `${zendeskBaseUrl}/${mapCulture(culture)}/articles/${articleOrSection}${anchor}`;
  }
  return `${zendeskBaseUrl}/${mapCulture(culture)}/articles/${articleOrSection}`;
};

export const getMyTicketsUrl = culture => `${zendeskBaseUrl}/${mapCulture(culture)}/requests`;

class ZendeskHelp extends PureComponent {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  render() {
    const { intl, className, article, anchor, ...rest } = this.props;
    const url = getZendeskUrl(article, intl.locale, false, anchor);

    return url ? (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer help external"
        className={classnames('margin5L zendesk-help', className)}
        title={intl.formatMessage(messages.OpenZendeskArticle)}
        style={{ verticalAlign: 'middle' }}
        {...rest}
      >
        <FaRegQuestionCircle className="react-icon" />
      </a>
    ) : null;
  }
}

export default injectIntl(ZendeskHelp);
